const Diandre = () => {
  return (
    <div className="Diandre_font">
      <p>
        Hi my name is Diandre and I am 29 years. I am a first generation
        American from Brooklyn, NY. I am currently a student at Pursuit learning
        various programming languages and frameworks such as JavaScript, React,
        Node, CSS, Bootstrap, and Express. I am also learning how to use various
        tools such as Git, GitHub, and vscode. I truly enjoy building web
        applications from scratch and the problem solving required to learn
        these skills.
        <br /> <br />
        Prior to joining Pursuit, I had a background in journalism and political
        science, so studying and learning new things is in my nature and has
        always been a passion of mine. Outside of Pursuit, I am a gym
        enthusiast. I've had various health issues throughout my life and many
        things have been out of my control. So I decided to take control of my
        health and fitness because it's something that I mostly have control of.
        <br /> <br />
        I actually decided to join Pursuit and get into software engineering
        because of the various health issues and I was forced to switch careers.
        It is seemingly a blessing in disguise. I am super grateful for what I
        have learned so far and I am excited for my future in software
        engineering.
        <br /> <br />
        I am also a huge sports fan. Basketball is my favorite sport, the lakers
        are my favorite team, and Kobe Bryant (RIP) is my favorite player. I've
        tried to adopt his mentality and work ethic daily to be the best
        possible person I can be. Hopefully within the next year I will land a
        job as a software engineer.
        <br /> <br />
        Check out my{" "}
        <a href="https://www.linkedin.com/in/diandre-miller/" target="_blank">
          {" "}
          LinkedIn
        </a>{" "}
        and{" "}
        <a href="https://github.com/DiandreMiller" target="_blank">
          {" "}
          GitHub{" "}
        </a>{" "}
        to see what I’ve been working on.
      </p>
    </div>
  );
};

export default Diandre;
